export const musicsConstants = {
	MusicsSaveRequest: "MUSICS_SAVE_STARTED",
	MusicsSaveSuccess: "MUSICS_SAVE_COMPLETED",
	MusicsSaveFailure: "MUSICS_SAVE_FAILED",

	MusicsGetByfilterRequest: "MUSICS_GET_BYFILTER_STARTED",
	MusicsGetByfilterSuccess: "MUSICS_GET_BYFILTER_COMPLETED",
	MusicsGetByfilterFailure: "MUSICS_GET_BYFILTER_FAILED",

	MusicsDetailRequest: "MUSICS_GET_DETAIL_STARTED",
	MusicsDetailSuccess: "MUSICS_GET_DETAIL_COMPLETED",
	MusicsDetailFailure: "MUSICS_GET_DETAIL_FAILED",

	MusicsDeleteRequest: "MUSICS_VIDEO_DELETE_STARTED",
	MusicsDeleteSuccess: "MUSICS_VIDEO_DELETE_COMPLETED",
	MusicsDeleteFailure: "MUSICS_VIDEO_DELETE_FAILED",

	MusicsVideoStatusUpdateRequest: "MUSICS_VIDEO_STATUS_UPDATE_STARTED",
	MusicsVideoStatusUpdateSuccess: "MUSICS_VIDEO_STATUS_UPDATE_COMPLETED",
	MusicsVideoStatusUpdateFailure: "MUSICS_VIDEO_STATUS_UPDATE_FAILED",
};
